import React from 'react';
import SycaiLogo from './SycaiLogo';

export const LoadingMark = () => <SycaiLogo style={{ width: 120, height: 34 }} />;

export default LoadingMark;
